import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { object, number } from "prop-types";

import { STATIC_KEYWORDS, TRENDING_STORY_FIELDS } from "../../../../constants";
import { getCollectionitems } from "../../../../../api/utils";
import { Headline } from "../../../atoms";

import { getCategoryAndSubCategory, getTemplateName, useTrackWidgetImpression } from "../../../../ga-utils";

import "./TrendingStories.m.css";

const TrendingStoriesCard = ({ trendingStory, story, config, serialNumber }) => {
  const { headline, slug } = trendingStory?.story;
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], {}));

  const trackEvent = () => {
    const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, pageType, config, story);
    const templateName = getTemplateName(story?.["story-template"] || pageType);

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "dl_story_interactions",
        event_action: "trending_story_click",
        link_position: serialNumber,
        category: category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: templateName,
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Link href={`/${slug}`} disableAjaxLinks={true} onMouseDown={trackEvent} onTouchStart={trackEvent}>
        <div styleName="story-card">
          <span styleName="story-index">{serialNumber}</span>
          <Headline type={6}>{headline}</Headline>
        </div>
      </Link>
    </>
  );
};

TrendingStoriesCard.propTypes = {
  trendingStory: object,
  story: object,
  config: object,
  serialNumber: number,
};

const TrendingStories = ({ story, qtConfig }) => {
  const [trendingStories, setTrendingStories] = useState([]);
  const { TRENDING_STORIES } = STATIC_KEYWORDS;
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], {}));
  const qtState = useSelector((state) => get(state, ["qt"], {}));

  useEffect(() => {
    getCollectionitems("trending-stories", 0, 4, TRENDING_STORY_FIELDS).then((trendingStoriesResult) => {
      let filteredStories = trendingStoriesResult?.filter((item) => item.id !== story.id);
      if (filteredStories.length > 4) {
        filteredStories = filteredStories?.splice(0, 4);
      }
      setTrendingStories(filteredStories);
    });
  }, [story.id]);

  const isBrowser = typeof window !== "undefined";


  const trackingOptions = {
    sectionName: "Trending Stories",
    pageType: pageType,
    location: isBrowser ? window.location : null,
    config: qtConfig || qtState.config,
    story: story,
    threshold: 0.2,
  };


  const containerRef = useTrackWidgetImpression(trackingOptions, {
    disabled: !(isBrowser && story && trendingStories.length > 0),
  });


  return (
    <>
      {trendingStories.length > 0 && (
        <div styleName="trending-stories-container" ref={containerRef}>
          <div styleName="trending-stories-heading">{TRENDING_STORIES}</div>

          <div styleName="story-card-wrapper">
            {trendingStories?.map((trendingStory, index) => (
              <TrendingStoriesCard
                trendingStory={trendingStory}
                story={story}
                config={qtConfig}
                key={trendingStory.id}
                serialNumber={index + 1}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

TrendingStories.propTypes = {
  story: object.isRequired,
  qtConfig: object,
};

export default TrendingStories;
